class StickyJacking extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement[]} */
    this.slides = Array.from(this.querySelectorAll(".slide"));
    /** @type {(e: Event) => void} */
    this.onScroll = this.onScroll.bind(this);
    /** @type {HTMLElement | null} */
    this.glowLine = this.querySelector(".glow-line");
  }

  connectedCallback() {
    if (!this.slides.length) return;


    // Listen to native scroll (no throttle needed)
    window.addEventListener("scroll", this.onScroll);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
  }

  /**
 * Calculates progressive opacity for a slide based on scroll progress.
 *
 * @param {number} progress - Normalized scroll progress (0 → 1)
 * @param {number} index - Slide index (0-based)
 * @param {number} total - Total number of slides
 * @returns {number} Opacity value between 0 and 1
 */
  progressiveOpacity(progress, index, total) {
    const segment = 1 / total;
    const local = (progress - index * segment) / segment;
    return Math.min(1, Math.max(0, local));
  }

  /**
   * Scroll handler: calculates progress and updates active slide
   * @param {Event} e
   */
  onScroll(e) {
    const rect = this.getBoundingClientRect();
    const sectionHeight = rect.height;
    const viewportHeight = window.innerHeight;

    if (rect.bottom < 0) return 100;
    if (rect.top > 0) return 0;

    const scrollableDistance = sectionHeight - viewportHeight;
    const scrolled = Math.min(scrollableDistance, Math.abs(rect.top));
    const progress = scrolled / scrollableDistance;

    if (this.glowLine) {
      this.glowLine.style.setProperty('--p', `${progress * 100}%`);
    }
    this.slides.forEach((slide, i) => {
      const opacity = this.progressiveOpacity(progress, i, this.slides.length);
      slide.style.opacity = opacity.toString();
    });
  }
}

if (!customElements.get("sticky-jacking")) {
  customElements.define("sticky-jacking", StickyJacking);
}
